/* eslint-disable no-case-declarations */
import actions from "./actions";

const {
  LIST_COUNTRIES_BEGIN,
  LIST_COUNTRIES_SUCCESS,
  LIST_COUNTRIES_ERR,
  CREATE_COUNTRY_BEGIN,
  CREATE_COUNTRY_SUCCESS,
  CREATE_COUNTRY_ERR,
} = actions;

const initState = {
  countries: [],
  totalCountries: 0,
  totalCountriesPages: 0,
  loadingListCountries: false,
  errorListCountries: "",
  loadingCreateCountry: false,
  errorCreateCountry: "",
};

const countriesReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_COUNTRIES_BEGIN:
      return {
        ...state,
        loadingListCountries: true,
        errorListCountries: false,
      };
    case LIST_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: [...data.results],
        loadingListCountries: false,
        errorListCountries: null,
      };
    case LIST_COUNTRIES_ERR:
      return {
        ...state,
        errorListCountries: err,
        loadingListCountries: false,
      };

    case CREATE_COUNTRY_BEGIN:
      return {
        ...state,
        loadingCreateCountry: true,
        errorCreateCountry: false,
      };
    case CREATE_COUNTRY_SUCCESS:
      return {
        ...state,
        loadingCreateCountry: false,
        errorCreateCountry: null,
      };
    case CREATE_COUNTRY_ERR:
      return {
        ...state,
        errorCreateCountry: err,
        loadingCreateCountry: false,
      };

    default:
      return state;
  }
};

export { countriesReducer };
